import React from "react";
import { Navigate, Routes as ReactRouterRoutes, Route } from "react-router-dom";

import LoginPage from "../pages/Login";

import { RoutesEnum } from "./enum/Routes";
import { LinkPage } from "../pages/Links";
import FullScreen from "@/design/Layout/FullScreen";
import { ProtectedRoute } from "./protected-route";
import { UsersPage } from "@/pages/UsersPage";
import { FeedbackPage } from "@/pages/FeedbackPage";
import { UpdatesPage } from "@/pages/UpdatesPage";
import { CompaniesPage } from "@/pages/CompaniesPage";
import { FoldersPage } from "@/pages/FoldersPage";
import { DataFolders } from "@/pages/DataFolders";
import LandingPage from "@/pages/Landing";
import { RequestPage } from "@/pages/RequestPage";

export const Routes: React.FC = () => {
  return (
    <ReactRouterRoutes>
      <Route path={RoutesEnum.ROOT} element={<LandingPage />} />
      <Route path={RoutesEnum.LINKS} element={<LinkPage />} />
      <Route path={RoutesEnum.LOGIN} element={<LoginPage />} />
      <Route
        path={RoutesEnum.RESTORE_PASSWORD_FORM}
        element={<RequestPage />}
      />

      <Route
        element={
          <ProtectedRoute>
            <FullScreen />
          </ProtectedRoute>
        }
      >
        <Route path={RoutesEnum.COMPANIES} element={<CompaniesPage />} />
        <Route path={RoutesEnum.USERS} element={<UsersPage />} />
        <Route path={RoutesEnum.FEEDBACK} element={<FeedbackPage />} />
        <Route path={RoutesEnum.UPDATES} element={<UpdatesPage />} />
        <Route path={RoutesEnum.FOLDERS} element={<FoldersPage />} />
        <Route path={RoutesEnum.DATA_FOLDERS} element={<DataFolders />} />
      </Route>

      <Route path="*" element={<Navigate to={RoutesEnum.COMPANIES} />} />
    </ReactRouterRoutes>
  );
};

export default Routes;
